<pf-app-layout>
    <cpw-app-header pf-app-header></cpw-app-header>
</pf-app-layout>
